/* global Swiper:false, YT:false, axios:false */
'use strict'

AndApp.top = {

  loadSrcCount: 0,
  displayLoadNum: 5,
  heroGalleryData: null,
  setHeroGalleryData () {
    const self = this
    const gallery = {
      itemElements: $('#js-heroGallery>ul>li'),
      appids: [],
      types: [],
      videos: [],
      behaviors: [],
      linkUrls: [],
      startSeconds: [],
      endSeconds: [],
      preregFlgs: []
    }

    for (let i = 0; i < gallery.itemElements.length; i++) {
      const targetElem = gallery.itemElements[i]
      gallery.types.push(targetElem.getAttribute('data-type'))
      gallery.appids.push(targetElem.getAttribute('data-appid'))
      gallery.videos.push(targetElem.getAttribute('data-videoid'))
      gallery.behaviors.push(targetElem.getAttribute('data-behavior'))
      gallery.linkUrls.push(targetElem.getAttribute('data-linkurl'))
      gallery.startSeconds.push(targetElem.getAttribute('data-startseconds'))
      gallery.endSeconds.push(targetElem.getAttribute('data-endseconds'))
      gallery.preregFlgs.push(targetElem.getAttribute('data-prereg'))
    }
    self.heroGalleryData = gallery
  },

  heroGalleryCarousel: null,
  setHeroGalleryCarousel () {
    const self = this
    const gallery = self.heroGalleryData

    // motionType取得（motionType === "STOP" -> ジャック広告の時）
    const motionType = $('#js-heroGallery').data('motiontype')

    const progressSet = function (seconds = 5) {
      if (motionType !== 'STOP') { // STOPの時はプログレスバーセットしない
        // デフォルトは５秒。引数があればその時間
        const progress = document.querySelector('.swiper-slide-active .sliderProgressBar')

        progress.style.transitionDuration = `${seconds}s`
        progress.style.width = '100%'
      }
    }

    let sliderTimer = null

    self.heroGalleryCarousel = new Swiper('#js-heroGallery', {
      slidesPerView: 2,
      loop: true,
      loopedSlides: 10,
      allowTouchMove: false,
      navigation: {
        nextEl: '.js-galleryNext',
        prevEl: '.js-galleryPrev'
      },
      preloadImages: true,
      on: {
        tap () {
          if (this.activeIndex > this.clickedIndex) {
            this.slidePrev()
          }
          if (this.activeIndex < this.clickedIndex) {
            this.slideNext()
          }
        },
        slidePrevTransitionStart () {
          slideChangeStart(document.querySelector('.swiper-slide-next').dataset.swiperSlideIndex, 'next')
        },
        slideNextTransitionStart () {
          slideChangeStart(document.querySelector('.swiper-slide-prev').dataset.swiperSlideIndex, 'prev')
        },
        transitionEnd () {
          if (motionType === 'STOP') return
          clearTimeout(sliderTimer)

          if (gallery.preregFlgs[this.realIndex] === 'true') {
            $('#js-goDetail').hide()
            $('#js-goPrereg').show()
          } else {
            $('#js-goPrereg').hide()
            $('#js-goDetail').show()
            $('#js-goDetail').attr('href', `${gallery.linkUrls[this.realIndex]}?from=top_movie`)
            if (gallery.behaviors[this.realIndex] === 'openTab') {
              console.log('openTab')
              $('#js-goDetail').attr('target', '_blank')
            } else {
              // これをやらないと_blankが消えない
              $('#js-goDetail').attr('target', '')
            }
          }

          $('#js-soundSwitchWrap').css({display: 'none'})
          if (gallery.types[this.realIndex] === 'image') {
            progressSet()
            sliderTimer = setTimeout(() => {
              this.slideNext()
            }, 5000)
          }

          $('#js-heroGallery div[id]').removeAttr('id')
          if (isMovieType(this.realIndex)) {
            document.querySelector('.swiper-slide-active').children[1].id = gallery.videos[this.realIndex]
            self.youtubePlayer.setMovie(gallery.videos[this.realIndex])
          }
        }
      }
    })
    self.heroGalleryCarousel.posterFadeOut = function () {
      $('.swiper-slide-active .poster').fadeOut(1500)
    }
    self.heroGalleryCarousel.progressSet = function (seconds) {
      progressSet(seconds)
    }

    function slideChangeStart (index, dir) {
      Array.from(document.querySelectorAll('.sliderProgressBar'), item => {
        item.style.transitionDuration = '0s'
        item.style.width = '0%'
      })
      if (isMovieType(index)) {
        $(`.swiper-slide-${dir} .poster`).fadeIn(500)
        self.youtubePlayer.stop()
      }
    }

    function isMovieType (index) {
      return (gallery.types[index] === 'youtube') && (gallery.videos[index] !== '')
    }
  },

  youtubePlayer: null,
  setYoutubePlayer () {
    const self = this
    self.youtubePlayer = {
      player: null,
      setOption (videoId) {
        const options = {
          width: 560,
          height: 315,
          videoId,
          playerVars: {
            rel: 0,
            controls: 0,
            showinfo: 0,
            wmode: 'transparent'
          },
          events: {
            'onReady': this.play,
            'onStateChange': this.ended
          }
        }
        return options
      },
      play (event) {
        if (!$('#js-soundSwitch').prop('checked')) {
          event.target.mute()
        } else {
          event.target.unMute()
        }
        // progressの設定
        if (document.querySelector('#js-heroGallery')) {
          self.heroGalleryCarousel.progressSet(event.target.getDuration())
        }

        const gallery = self.heroGalleryData
        const currentSlide = document.querySelector('.swiper-slide-active')
        const currentSlideIndex = currentSlide.getAttribute('data-swiper-slide-index')

        setTimeout(() => {
          // iframe(Youtube)のpropertyがnullのときplayVideo()で表示するYoutubeのsrcが取得できないエラーが発生する対応
          Object.keys(event.target).some(k => {
            if (typeof event.target[k] === 'object' && event.target[k] !== null) {
              Object.keys(event.target[k]).some(l => {
                const videoObj = event.target[k][l]
                if (typeof videoObj === 'object' && videoObj !== null && videoObj.videoId !== undefined) {
                  const player = event.target
                  const startSeconds = gallery.startSeconds[currentSlideIndex]
                  const endSeconds = gallery.endSeconds[currentSlideIndex]

                  player.loadVideoById({
                    videoId: videoObj.videoId,
                    startSeconds,
                    endSeconds
                  })

                  player.playVideo()
                  self.heroGalleryCarousel.posterFadeOut()
                  return true
                }

                return false
              })
            }
          })
        }, 2000)
      },
      stop () {
        if (this.player && this.player.getIframe()) {
          this.player.destroy()
        }
      },
      mute () {
        this.player.mute()
      },
      unMute () {
        this.player.unMute()
      },
      ended (event) {
        if (event.data === YT.PlayerState.ENDED) {
          event.target.destroy()
          self.heroGalleryCarousel.slideNext()
        }
      },
      setMovie (movieId) {
        this.player = new YT.Player(movieId, this.setOption(movieId))
        $('#js-soundSwitchWrap').css({display: 'block'})
      }
    }
  }
}

function onYouTubeIframeAPIReady () {
  AndApp.top.setYoutubePlayer()
  AndApp.top.setHeroGalleryData()
  AndApp.top.setHeroGalleryCarousel()

  // 紹介動画枠
  if (AndApp.customMoviePlayerForYT.youtubeMovieNormal) {
    AndApp.customMoviePlayerForYT.setYoutubePlayerNormal()
    AndApp.customMoviePlayerForYT.youtubePlayerNormal.setMovie(AndApp.customMoviePlayerForYT.youtubeMovieNormal.getAttribute('data-videoid'))
  }
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

(function () {
  $('#js-soundSwitch').on('click', function () {
    if (this.checked) {
      AndApp.top.youtubePlayer.unMute()
    } else {
      AndApp.top.youtubePlayer.mute()
    }
  })
}())

// レクタングルバナーのスクロール追従設定
// http://chibinowa.net/note/js/fixedsidebar.html#test02
const fixedSidebarBanner = (() => {
  const minWidth = 1200
  const minLeftPos = 880

  let $window
  let $banner
  let $main
  let $header
  let mainScroll
  let fixedStart
  let fixpxTop
  let fixpxEndTop

  function onScroll () {
    const scrollTop = $window.scrollTop()
    const scrollLeft = $window.scrollLeft()

    if (scrollTop > mainScroll) {
      // 固定する上限
      $banner.css({
        position: 'fixed',
        top: `${fixpxEndTop - scrollTop}px`,
        left: $window.width() < minWidth ? `${minLeftPos - scrollLeft}px` : 'auto'
      })
    } else if (scrollTop > fixedStart) {
      // 固定中間
      $banner.css({
        position: 'fixed',
        top: `${fixpxTop}px`,
        left: $window.width() < minWidth ? `${minLeftPos - scrollLeft}px` : 'auto'
      })
    } else {
      // 固定開始まで
      $banner.css({
        position: 'relative',
        top: 'auto',
        left: 'auto'
      })
    }
  }

  return {
    run () {
      $window = $(window)
      // 固定するバナー
      $banner = $('#js-rectangleBanner')
      // メインカラム
      $main = $('#js-rectangleBanner_mainColumn')
      // グローバルヘッダー
      $header = $('#js-headerArea')

      if ($banner.length) {
        this.refresh()

        $window.on('resize', () => {
          this.refresh()
        })
      }
    },
    // 基準になる数値の計算
    refresh () {
      $window.off('scroll', onScroll)

      $banner.css({
        position: 'relative',
        top: 'auto'
      })

      // 横スクロールが出ているときは追従させない
      if ($window.width() < minWidth) {
        return
      }

      // メインカラムとバナーの上部
      const bannerTop = $banner.offset().top - parseInt($banner.css('margin-top'), 10)
      const mainTop = $main.offset().top - parseInt($main.css('margin-top'), 10)

      const windowHeight = $window.height()
      const mainOuterHeight = $main.outerHeight()
      const headerHeight = $header.outerHeight() + 20// マージン分追加
      const bannerOuterHeight = $banner.outerHeight() + headerHeight + 100// ページトップへ戻るボタンを考慮

      if (bannerTop + bannerOuterHeight < mainTop + mainOuterHeight) {
        // 開始時のTOP基準値
        fixpxTop = (Math.max(bannerOuterHeight - windowHeight, 0) - headerHeight) * -1
        // ウィンドウにバナー（固定要素すべて）が収まる場合
        if (windowHeight > bannerOuterHeight) {
          // スクロール上限（固定ヘッダー分考慮）
          //   最後の「+60」は、.has-topJackBanner .o-wrapperの下余白20pxと
          //   mainContent内のC-contentsの下マージン40pxの合計
          mainScroll = mainTop + mainOuterHeight - windowHeight - (bannerOuterHeight - windowHeight) + headerHeight + 60
          // 開始位置：バナーのTOP（固定ヘッダー分考慮）
          fixedStart = bannerTop - headerHeight
          // 終了時のTOP基準値（固定ヘッダー分考慮）
          fixpxEndTop = mainScroll + headerHeight
        } else {
          // ウィンドウにバナーが収まらない場合
          // スクロール上限
          //   最後の「+60」は、.has-topJackBanner .o-wrapperの下余白20pxと
          //   mainContent内のC-contentsの下マージン40pxの合計
          mainScroll = mainTop + mainOuterHeight - windowHeight + 60
          // 開始位置：バナーのBOTTOMがウィンドウに表示されたら（固定ヘッダー分考慮）
          fixedStart = bannerTop + bannerOuterHeight - windowHeight - headerHeight
          // 終了時のTOP基準値（固定ヘッダー分考慮）
          fixpxEndTop = mainScroll - (bannerOuterHeight - windowHeight) + headerHeight
        }
        $window.on('scroll', onScroll)
      }
      $window.trigger('scroll')
    }
  }
})()

// グローバルヘッダー固定
window.fixedGlobalHeader = (() => {
  const $window = $(window)
  const $header = $('#js-headerArea')
  const headerHeight = $header.outerHeight()
  const trigger = document.querySelector('#js-globalHeader_fixedStartTrigger').offsetTop
  const fixedClass = 'is-globalHeaderFixed'
  const readyClass = 'is-globalHeaderFixed-ready'
  let fixedHeaderFlag

  $window.on('load scroll', () => {
    const height = $window.scrollTop()

    if (height > headerHeight && height < trigger) {
      $header.addClass(readyClass)
    } else if (height >= trigger) {
      $header.removeClass(readyClass).addClass(fixedClass)
    } else {
      $header.removeClass(`${readyClass} ${fixedClass}`)
    }
  })

  // 画面幅1200px以下の時の対応
  $window.on('resize load scroll', () => {
    fixedHeaderFlag = $window.width() < 1200 && $header.hasClass(fixedClass)
  })

  $window.on('scroll', () => {
    if (fixedHeaderFlag) {
      $header.css({
        'left': -$window.scrollLeft(),
        'width': 'auto'
      })
    } else {
      $header.removeAttr('style')
    }
  })
})()

$(function () {
  const $imgs = $('.c-preload-img')
  AndApp.top.displayLoadNum = $imgs.length

  $imgs.bind('load', function () {
    if (this.complete) {
      AndApp.top.loadSrcCount++
    }
    if (AndApp.top.loadSrcCount >= AndApp.top.displayLoadNum) {
      $('.loader').hide()
      $('#heroLoading').fadeOut()
    }
  }).load()

  // レクタングルバナー
  fixedSidebarBanner.run()

  // jsRenderのdelimitersを変更する
  $.views.settings.delimiters('[[', ']]')

  // Youtube動画のiframeを初期化
  AndApp.customMoviePlayerForYT.init()

  // ゲームリストを出力
  function createGameList (listName, apiPath) {
    const list = listName
    const path = apiPath
    if (!list || !path) {
      return
    }

    axios.get(path).then((response) => {
      if (!response.data.apps) {
        return
      }

      $(`#js-top-${list}-apps-ul`).append(
        $(`#js-top-${list}-app-li`).render(response.data)
      )
      $(`#js-top-${list}-apps`).removeClass('u-d-none')

      // レクタングルバナーがある場合の処理
      if ($('#js-rectangleBanner').length) {
        fixedSidebarBanner.refresh()
      }
    }).catch((error) => {
      console.error(error)
    })
  }

  // 新着ゲーム
  createGameList('new', '/api/1.0.0/new_apps')

  // おすすめゲーム
  createGameList('recommended', '/api/1.0.0/recommended_apps')

  // 事前登録中のゲーム
  createGameList('prereg', '/api/1.0.0/prereg_apps')

  // 上部お知らせ フォーカスアウトの設定
  $('#js-headerInfo_mouseoutTrigger').mouseleave(
    function () {
      $('#js-headerInfo_switch').removeAttr('checked')
    })
})
